import React from 'react';
import { connect } from 'react-redux';
import { fetchUsuarios, setFiltroUsuarios } from '../../actions/usuariosActions';
import FiltroUsuarios from '../../components/Usuarios/FiltroUsuarios';
import BtnToggleFilter from "../General/Filter/BtnToggleFilter";
import BigSpinner from '../General/BigSpinner';
import UserListItem from './UserListItem';
import ReactPaginate from 'react-paginate';
import { withNavigation } from '../General/withNavigation';

class ListModeradores extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nombreBusqueda: "",
        };
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    componentDidMount() {
        this.buscarUsuarios();
    }

    buscarUsuarios = (isFromFilter = false) => {
        const { idSeller, filtro } = this.props;
        this.props.fetchUsuarios({
            idSeller,
            numeroPagina: filtro?.numeroPagina || 1,
            nombreUsuario: this.state.nombreBusqueda || undefined,
            activo: filtro?.activo
        });

        if (isFromFilter) {
            this.props.setFiltroUsuarios({ ...filtro, numeroPagina: 1 });
        }
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        const nuevoFiltro = { ...this.props.filtro, numeroPagina: selectedPage };

        if (this.state.nombreBusqueda.length >= 3) {
            nuevoFiltro.nombreUsuario = this.state.nombreBusqueda;
        } else {
            delete nuevoFiltro.nombreUsuario;
        }

        this.props.setFiltroUsuarios(nuevoFiltro).then(() => this.buscarUsuarios());
    };

    onUsuario = (id) => {
        this.props.navigate(`/Usuarios/Editar/${id}`);
    };

    handleShowFilter = () => {
        const nuevoValor = !(this.props.filtro?.showFilter ?? true);
        this.props.setFiltroUsuarios({
            ...this.props.filtro,
            showFilter: nuevoValor
        });
    };


    goToUserNuevo = (dropdownSelect) => {
        this.props.navigate("/Usuarios/NuevoUser", {
            state: { dropdownSelect }
        });
    };

    actualizarNombreBusqueda = (nombre) => {
        this.setState({ nombreBusqueda: nombre.length >= 3 ? nombre : "" });
    };

    handleReset = () => {
        const params = { nombreUsuario: "", numeroPagina: 1, showFilter: true, activo: undefined };
        this.setState({ nombreBusqueda: "" });
        this.props.setFiltroUsuarios(params).then(() => this.buscarUsuarios(true));
    };

    render() {
        const { userType, userName, usuarios, isLoading, cantidadTotal, filtro } = this.props;

        return (
            <div className="container">
                <div className="row align-items-center justify-content-between page-titles">
                    <div className="col-12 col-sm-6">
                        <h3 className="text-themecolor color-rojo-megatone">{userName}</h3>
                    </div>
                    <div className="button-group col-12 col-sm-6 text-end mt-2 mt-sm-0 d-flex align-items-center justify-content-end">

                        {userType.isAdminMod &&
                            <button
                                type="button"
                                onClick={() => this.goToUserNuevo(2)}
                                className="btn btn-sm btn-green"
                            >
                                <i className="fa fa-plus-circle mx-1" />
                                Crear Proveedor
                            </button>
                        }

                        {(userType.isAdminMod || userType.isSellerAdmin) &&
                            <button
                                type="button"
                                onClick={() => this.goToUserNuevo(0)}
                                className="btn btn-sm btn-green"
                            >
                                <i className="fa fa-plus-circle mx-1" />
                                {userType.isAdminMod ? "Crear Moderador" : "Crear Usuario"}
                            </button>
                        }

                        <BtnToggleFilter
                            show={this.props.filtro?.showFilter ?? true}
                            handleShow={this.handleShowFilter}
                        />
                    </div>
                </div>

                <div hidden={!(this.props.filtro?.showFilter ?? true)}>
                    <FiltroUsuarios
                        filtro={filtro}
                        fetchUsuarios={() => this.buscarUsuarios(true)}
                        actualizarNombreBusqueda={this.actualizarNombreBusqueda}
                        handleReset={this.handleReset}
                    />
                </div>

                {isLoading ? <BigSpinner /> :
                    <div>
                        {usuarios?.length > 0 ?
                            <ul className="list-group">
                                {usuarios.map((usuario) => (
                                    <div key={usuario.idUsuario} onClick={() => this.onUsuario(usuario.idUsuario)}>
                                        <UserListItem
                                            id={usuario.idUsuario}
                                            nombreUsuario={usuario.nombreUsuario}
                                            email={usuario.email}
                                        />
                                    </div>
                                ))}
                            </ul>
                            :
                            <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                                No se encontraron usuarios
                            </h5>
                        }
                    </div>
                }

                <div className="d-flex justify-content-center">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={Math.ceil((cantidadTotal || 0) / 10)}
                        marginPagesDisplayed={10}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={Math.max(0, (filtro?.numeroPagina || 1) - 1)}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isLoading: state.usuarios.isLoading,
    userType: state.general.userType,
    userName: state.general.userName,
    idSeller: state.general.idSeller,
    usuarios: state.usuarios.usuarios,
    filtro: state.usuarios.filtro,
    cantidadTotal: state.usuarios.cantidadTotal,
    cantidadPagina: state.usuarios.cantidadPagina
});

export default withNavigation(connect(mapStateToProps, {
    fetchUsuarios,
    setFiltroUsuarios
})(ListModeradores));
